import * as React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { NavigatorData, Operations } from './NavigatorData';
import ConfigContent from './ConfigContent';
import FormDataType, { ActionPayload } from './ConfigFormData';
import { ProgressDataType } from './Paperbase';
import { CustomerSubscription } from './SubscriptionData';

export interface ConfigContentProps {
  onFormChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onFormDrop: (event: React.DragEvent<HTMLInputElement>, inputFileName: string) => void;
  formValues: FormDataType;
  updateFormValues: React.Dispatch<ActionPayload>;
  runOperation: () => void;
  downloadResult: () => void;
  allProgressData: ProgressDataType,
  onClearInputs: () => void;
  customerSubscriptionData: CustomerSubscription
}

function ConfigContentWrapper(props: ConfigContentProps ) {
  let { url } = useRouteMatch();
  let { allProgressData, customerSubscriptionData } = props;

  return (
    <Switch>
      <Route path={`${url}${NavigatorData.getPathForOperation(Operations.compare)}`}>
        <ConfigContent onFormDrop={props.onFormDrop} operationType={Operations.compare} onFormChange={props.onFormChange} onClearInputs={props.onClearInputs}
        formValues={props.formValues} updateFormValues={props.updateFormValues} runOperation={props.runOperation} allProgressData={allProgressData} downloadResult={props.downloadResult} customerSubscriptionData={customerSubscriptionData} />
      </Route>
      <Route path={`${url}${NavigatorData.getPathForOperation(Operations.twoWayMerge)}`}>
        <ConfigContent onFormDrop={props.onFormDrop} operationType={Operations.twoWayMerge} onFormChange={props.onFormChange} onClearInputs={props.onClearInputs}
        formValues={props.formValues} updateFormValues={props.updateFormValues} runOperation={props.runOperation} allProgressData={allProgressData} downloadResult={props.downloadResult} customerSubscriptionData={customerSubscriptionData} />
      </Route>
      <Route path={`${url}${NavigatorData.getPathForOperation(Operations.threeWayMerge)}`}>
        <ConfigContent onFormDrop={props.onFormDrop} operationType={Operations.threeWayMerge} onFormChange={props.onFormChange} onClearInputs={props.onClearInputs}
        formValues={props.formValues} updateFormValues={props.updateFormValues} runOperation={props.runOperation} allProgressData={allProgressData} downloadResult={props.downloadResult} customerSubscriptionData={customerSubscriptionData} />
      </Route>
      <Route path={`${url}${NavigatorData.getPathForOperation(Operations.graft)}`}>
        <ConfigContent onFormDrop={props.onFormDrop} operationType={Operations.graft} onFormChange={props.onFormChange} onClearInputs={props.onClearInputs}
        formValues={props.formValues} updateFormValues={props.updateFormValues} runOperation={props.runOperation} allProgressData={allProgressData} downloadResult={props.downloadResult} customerSubscriptionData={customerSubscriptionData} />
      </Route>
      <Route path={`${url}${NavigatorData.getPathForOperation(Operations.patch)}`}>
        <ConfigContent onFormDrop={props.onFormDrop} operationType={Operations.patch} onFormChange={props.onFormChange} onClearInputs={props.onClearInputs}
        formValues={props.formValues} updateFormValues={props.updateFormValues} runOperation={props.runOperation} allProgressData={allProgressData} downloadResult={props.downloadResult} customerSubscriptionData={customerSubscriptionData} />
      </Route>
      <Route path="/">
        <ConfigContent onFormDrop={props.onFormDrop} operationType={Operations.compare} onFormChange={props.onFormChange} onClearInputs={props.onClearInputs}
        formValues={props.formValues} updateFormValues={props.updateFormValues} runOperation={props.runOperation} allProgressData={allProgressData} downloadResult={props.downloadResult} customerSubscriptionData={customerSubscriptionData} />
      </Route>
    </Switch>
  )

}

export default (ConfigContentWrapper);